import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';

registerModuleCatalog('reconciliation', (locale) => import(`./locales/${locale}.po`), { eager: true });
export const loadReconciliationMessages = () => ensureModuleMessages('reconciliation');
